// Shared helpers for showing stock prices. The API returns null (not 0) when a
// price is unavailable; older responses may still send 0, so treat both alike.

const NUMBER_FORMAT = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

export const RED = '#ff5348';
export const GREEN = '#00ba77';
export const GREY = '#8a8a8a';

export function isPriceAvailable(stock) {
	if (!stock) return false;
	if (stock.price_status === 'unavailable') return false;
	const price = Number(stock.current_price);
	return Number.isFinite(price) && price > 0;
}

// Listed and priced. Stocks that can't be traded are left out of every list.
export function isTradeable(stock) {
	return !!stock && stock.is_active !== false && isPriceAvailable(stock);
}

export function formatPrice(price) {
	if (price === null || price === undefined || price === '') return '—';
	const value = Number(price);
	if (!Number.isFinite(value) || value === 0) return '—';
	return value.toLocaleString('en-NG', NUMBER_FORMAT);
}

// "—" when there is no data (unavailable price); a real zero change stays "0.00".
export function formatChange(change) {
	if (change === null || change === undefined || change === '') return '—';
	const value = Number(change);
	if (!Number.isFinite(value)) return '—';
	return value.toLocaleString('en-NG', NUMBER_FORMAT);
}

// "+1.25%" / "-0.40%" / "0.00%", or "—" when there is no data
export function formatPercent(percent) {
	if (percent === null || percent === undefined || percent === '') return '—';
	const value = Number(percent);
	if (!Number.isFinite(value)) return '—';
	if (value === 0) return '0.00%';
	return `${value > 0 ? '+' : ''}${value.toLocaleString('en-NG', NUMBER_FORMAT)}%`;
}

// Red for a fall, green for a rise, grey when there is no change or no data.
export function changeColor(value) {
	const n = Number(value);
	if (value === null || value === undefined || !Number.isFinite(n) || n === 0) return GREY;
	return n < 0 ? RED : GREEN;
}

export function changeStyle(value) {
	return { color: changeColor(value) };
}

export function staleNote(stock) {
	if (stock?.price_status === 'stale' && stock?.as_of) return `as of ${stock.as_of}`;
	return null;
}

export const PRICE_UNAVAILABLE_MESSAGE = 'Price unavailable for this stock right now';
